export const ActionTypes = {
  LOADING: "USER_LOADING",
  ERROR: "USER_ERROR",
  SUCCESS: "USER_SUCCESS",
};
